import { Pressable, Text, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { css } from 'styled-components';
import styled from 'styled-components/native';
import { mixins } from '~/theme';

export const TopContainer = styled(Animated.View)`
    width: 100%;
    padding: 12px 16px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: absolute;
    // NOTE: prevents glitches on web when scrolling
    top: -1px;
`;
export const MainContainer = styled(Animated.ScrollView)`
    padding: 60px 16px;
`;

export const TopHandleWrapper = styled(View)`
    margin-bottom: 8px;
`;
export const TopContentWrapper = styled(View)`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;
export const ContentWrapper = styled(Pressable)`
    padding: 16px 0;
    border: 1px solid ${({ theme }) => theme.palette.opacity['12'].rgba};
    border-top-width: 0;
    border-left-width: 0;
    border-right-width: 0;
    flex-direction: row;
`;
const BaseTitleWrapperStyles = css`
    flex-direction: row;
    align-items: center;
`;

export const TrainingTitleInside = styled(Text)`
    ${mixins.typography.h.semiBold20}
    color: ${({ theme }) => theme.text.primary};
`;

export const CycleTitleInside = styled(Text)`
    ${mixins.typography.h.semiBold20}
    color: ${({ theme }) => theme.text.secondary};
`;

export const TitleWrapper = styled(Animated.View)`
    ${BaseTitleWrapperStyles}
`;

export const Title = styled(Text)`
    ${mixins.typography.h.semiBold18}
    color: ${({ theme }) => theme.text.primary};
`;

export const ButtonWrapper = styled(View)`
    flex-direction: row;
`;

const BaseButtonWrapperStyles = css`
    padding: 8px;
    border-radius: 12px;
`;

export const CloseButtonWrapper = styled(Pressable)`
    ${BaseButtonWrapperStyles};
    background-color: ${({ theme }) => theme.fill.level4};
`;

export const ItemLabel = styled(Text)`
    flex: 1;
    ${mixins.typography.ui.regular16}
    color: ${({ theme }) => theme.text.primary};
`;

export const ItemSelectedIcon = styled(View)`
    margin-left: 16px;
`;
